import { render, staticRenderFns } from "./PaDeptGmv.vue?vue&type=template&id=44205f70&scoped=true"
import script from "./PaDeptGmv.vue?vue&type=script&lang=js"
export * from "./PaDeptGmv.vue?vue&type=script&lang=js"
import style0 from "./PaDeptGmv.vue?vue&type=style&index=0&id=44205f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44205f70",
  null
  
)

export default component.exports